import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    highlightClass: { type: String, default: "bg-custom-blue-1" },
  }

  connect() {
    this.abortController = new AbortController()

    this.element.addEventListener(
      "mouseover",
      (event) => this.highlight(event),
      {
        signal: this.abortController.signal,
      },
    )

    this.element.addEventListener("mouseout", () => this.clearHighlight(), {
      signal: this.abortController.signal,
    })
  }

  disconnect() {
    this.abortController.abort()
  }

  highlight(event) {
    const cell = event.target.closest("th, td")
    if (!cell) return

    const productId = cell.dataset.productId
    if (typeof productId === "undefined") return

    this.highlightProductColumns(productId)
  }

  clearHighlight() {
    const highlightedCells = this.element.querySelectorAll(
      `.${this.highlightClassValue}`,
    )
    highlightedCells.forEach((cell) => {
      cell.classList.remove(this.highlightClassValue)
    })
  }

  highlightProductColumns(productId) {
    this.clearHighlight()

    const cells = this.element.querySelectorAll(
      `[data-product-id="${productId}"]`,
    )
    cells.forEach((cell) => {
      cell.classList.add(this.highlightClassValue)
    })
  }
}
